import { storageProvider } from '@ocean/configs'
import { UserLoginParams, GetAccountResponse } from 'modules/Auth/types'

export const USER_LOGIN_PARAMS = 'USER_LOGIN_PARAMS'
export const USER_ACCOUNT_INFO = 'USER_ACCOUNT_INFO'

class UserUtils {
  storeUserLoginParams(authUserParams: UserLoginParams) {
    const { password, ...rest } = authUserParams
    storageProvider.setItem(USER_LOGIN_PARAMS, JSON.stringify({ ...rest }))
  }

  getUserLoginParams(): UserLoginParams {
    return JSON.parse(storageProvider.getItem(USER_LOGIN_PARAMS) || '{}')
  }

  clearUserInfo() {
    storageProvider.removeItem(USER_LOGIN_PARAMS)
    storageProvider.removeItem(USER_ACCOUNT_INFO)
  }

  storeUserAccountInfo(userAccountInfo: GetAccountResponse) {
    storageProvider.setItem(USER_ACCOUNT_INFO, JSON.stringify(userAccountInfo))
  }

  getUserAccountInfo(): GetAccountResponse {
    return JSON.parse(storageProvider.getItem(USER_ACCOUNT_INFO) || '{}')
  }
}

export default new UserUtils()
